import { useState } from "react";

const MAIN = "Iran · US · Israel";
const ago = (ts) => {
  const m = Math.round((Date.now() - new Date(ts)) / 60000);
  return m < 60 ? `${m}m` : m < 1440 ? `${Math.round(m / 60)}h` : `${Math.round(m / 1440)}d`;
};
// other wars only when AI rates a real gold effect
const relevant = (h) => h.tag && (h.region === MAIN ? h.tag.strength >= 2 : h.tag.strength >= 3);

const Item = ({ h }) => (
  <li className="py-3 border-b border-[color:var(--line)] last:border-none" data-testid={`desk-cf-${h.key}`}>
    <div className="flex items-center gap-2 flex-wrap mb-1">
      <span className={`desk-tag ${h.tag.impact}`}>{h.tag.impact} · {h.tag.strength}</span>
      <span className="desk-region">{h.region}</span>
      <span className="text-sm text-[color:var(--mute)]">{h.source} · {ago(h.published)}</span>
    </div>
    <a href={h.link || undefined} target="_blank" rel="noreferrer noopener" className="text-lg font-semibold leading-snug hover:text-[color:var(--gold)]">{h.title}</a>
    {h.tag.reason && <div className="text-base text-[color:var(--mute)] mt-1">{h.tag.reason}</div>}
  </li>
);

export const ConflictWatch = ({ items = [] }) => {
  const [all, setAll] = useState(false);
  const rows = items.filter(relevant).sort((a, b) => b.tag.strength - a.tag.strength || (b.published > a.published ? 1 : -1));
  const shown = all ? rows : rows.slice(0, 4);
  return (
    <section className="desk-card !border-[rgba(229,72,77,.45)]" data-testid="desk-conflict">
      <h2 className="!text-[color:var(--red)]">Conflict watch · strikes &amp; missiles</h2>
      <p className="text-sm text-[color:var(--mute)] mb-2">Iran, US and Israel first. Other wars appear only when they are likely to move gold. Gold often spikes on a strike, then can drop fast: trade the reaction, not the headline.</p>
      {rows.length === 0 ? <p className="text-base text-[color:var(--mute)]" data-testid="desk-cf-empty">No gold-relevant conflict headlines right now.</p> :
        <ul data-testid="desk-cf-list">{shown.map((h) => <Item key={h.key} h={h} />)}</ul>}
      {rows.length > 4 && <button className="desk-more" onClick={() => setAll(!all)} data-testid="desk-cf-toggle">{all ? "Show top 4" : `Show all ${rows.length}`}</button>}
    </section>
  );
};
